import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import DashboardOverviewPage from "./pages/DashboardOverviewPage";
import CreateTanneryPage from "./pages/CreateTanneryPage";
import CreateUsersPage from "./pages/CreateUsersPage";
import SuperAdminUsersPage from "./pages/SuperAdminUsersPage";
import SuperAdminTokensPage from "./pages/SuperAdminTokensPage";
import SettingsPage from "./pages/SettingsPage";
import TokensPage from "./pages/TokensPage";
import LogsPage from "./pages/LogsPage";
import ScorePage from "./pages/ScorePage";
import ZilaManagementPage from "./pages/ZilaManagementPage";
import DownloadApkPage from "./pages/DownloadApkPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/download-apk" element={<DownloadApkPage />} />
      <Route path="/dashboard" element={<DashboardPage />}>
        <Route index element={<DashboardOverviewPage />} />
        <Route path="create-tannery" element={<CreateTanneryPage />} />
        <Route path="create-users" element={<CreateUsersPage />} />
        <Route path="super-admin-users" element={<SuperAdminUsersPage />} />
        <Route path="super-admin-tokens" element={<SuperAdminTokensPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="tokens" element={<TokensPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="score" element={<ScorePage />} />
        <Route path="zila-management" element={<ZilaManagementPage />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
